import React, {FC, useEffect} from 'react';

import styled from 'styled-components';
import {getDataClientId} from '../../../pages/OrderDetail/utils/getKlarnaScriptClientId';
import {Locale} from '../../../types';
import {useScriptCallback} from '../../../utils/hooks/useScript';
import {primaryColor} from '../../constants/colors';
import {fsL, fsS} from '../../constants/typography';
import {getKlarnaPlaceholder} from './getKlarnaSnippet';

const KLARNA_SERVICES_SCRIPT = 'https://eu-library.klarnaservices.com/lib.js';

export const ArticleContent: FC<{
  activeArticle: {id: number; body: string};
  locale: Locale;
}> = ({activeArticle, locale}) => {
  const klarnaCustomElement = getKlarnaPlaceholder(activeArticle.id, locale);
  const {loadScript} = useScriptCallback(KLARNA_SERVICES_SCRIPT, {
    async: '',
    'data-client-id': getDataClientId(locale),
  });

  useEffect(() => {
    if (klarnaCustomElement && !window?.KlarnaOnsiteService?.loaded) {
      loadScript();
    }
    // @see https://docs.klarna.com/on-site-messaging/faq/#what-is-refreshing-placements
    if (klarnaCustomElement && window?.KlarnaOnsiteService?.loaded) {
      window.KlarnaOnsiteService.push({eventName: 'refresh-placements'});
    }
  }, [klarnaCustomElement]);

  return (
    <Content
      data-testid="HelpCenterArticlePageText"
      dangerouslySetInnerHTML={{
        __html: injectKlarnaSnippet(activeArticle.body, klarnaCustomElement),
      }}
    />
  );
};

function injectKlarnaSnippet(articleBody: string, klarnaCustomElement: string) {
  return klarnaCustomElement || articleBody;
}

const Content = styled.div`
  font-size: ${fsS}px;
  font-weight: 500 !important;
  line-height: 2;

  span {
    font-weight: 500 !important;
  }

  p {
    margin-bottom: 30px;
    &::last-child {
      margin-bottom: 0;
    }
  }

  ul,
  ol {
    margin-left: 30px;
    max-width: calc(100% - 30px);
    li {
      padding-left: 10px;
      box-sizing: border-box;
    }
  }

  strong {
    font-weight: 600 !important;
  }

  a {
    color: ${primaryColor};
  }

  h1,
  h2,
  h3,
  h4,
  h5 {
    font-size: ${fsL}px;
    font-weight: 600 !important;
    margin-bottom: 0;
    margin-top: 20px;
    span {
      font-weight: 600 !important;
    }
  }

  .wysiwyg-underline {
    text-decoration: underline;
  }
  .wysiwyg-text-align-center {
    text-align: center;
  }
`;
